import { render, staticRenderFns } from "./commodityEdit.vue?vue&type=template&id=6992361a&scoped=true&"
import script from "./commodityEdit.vue?vue&type=script&lang=ts&"
export * from "./commodityEdit.vue?vue&type=script&lang=ts&"
import style0 from "./commodityEdit.vue?vue&type=style&index=0&id=6992361a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6992361a",
  null
  
)

export default component.exports